import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgFinancialProducts = function SvgFinancialProducts(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsx("rect", {
      width: 32,
      height: 32,
      fill: "white"
    }, void 0), jsx("path", {
      d: "M20 11C20 8.23858 17.9853 6 15.5 6C13.0147 6 11 8.23858 11 11",
      stroke: "currentColor",
      strokeWidth: 1.5
    }, void 0), jsx("path", {
      d: "M22.1916 11H8.33725C7.85277 11 7.43799 11.3473 7.35282 11.8242L5.20996 23.8242C5.10051 24.4371 5.57176 25 6.19439 25H24.763C25.3997 25 25.8742 24.413 25.7408 23.7905L23.1694 11.7905C23.0706 11.3294 22.6631 11 22.1916 11Z",
      stroke: "currentColor",
      strokeWidth: 1.5
    }, void 0)]
  }), void 0);
};

export { SvgFinancialProducts as default };
